import { useState } from 'react'
import { type ArrayFieldTemplateItemType } from '@rjsf/utils'

export const useExpandedItems = (items: ArrayFieldTemplateItemType[], errorIndexes: number[], generation: number) => {
  const itemKeys = items.map((item) => item.key)
  const [knownKeys, setKnownKeys] = useState<string[]>(itemKeys)
  const [trackedGeneration, setTrackedGeneration] = useState(generation)
  const [openKey, setOpenKey] = useState<string | null>(null)

  if (generation !== trackedGeneration) {
    setTrackedGeneration(generation)
    setKnownKeys(itemKeys)
    setOpenKey(null)
  } else if (itemKeys.join('|') !== knownKeys.join('|')) {
    const added = itemKeys.filter((key) => !knownKeys.includes(key))
    const kept = knownKeys.filter((key) => itemKeys.includes(key))
    setKnownKeys(itemKeys)
    if (added.length > 0 && kept.length === knownKeys.length) {
      setOpenKey(added[added.length - 1])
    } else if (kept.length === 0) {
      setOpenKey(null)
    }
  }

  const heldOpen = (item: ArrayFieldTemplateItemType) => errorIndexes.includes(item.index)

  return {
    heldOpen,
    isOpen: (item: ArrayFieldTemplateItemType) => openKey === item.key || heldOpen(item),
    toggle: (key: string) => setOpenKey((current) => (current === key ? null : key)),
  }
}
